import {initDebugger} from "felles-ng2/støttefunksjoner/debug";
import {ChangeDetectionStrategy, Component, input} from "@angular/core";

const debug = initDebugger('TittelVerdiSamlingKomponent');

/** Samling av {@link TittelVerdiKomponent}, med støtte for ulike formateringer. */
@Component({
    selector: 'tittel-verdi-samling',
    template: `
        <ng-content></ng-content>`,
    styleUrl: 'tittel-verdi-samling.scss',
    host: {'[class]': 'stil()'},
    standalone: true,
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class TittelVerdiSamlingKomponent {

    /** Angir visningsstil */
    stil = input<SamlingStil>('vertikal')

}

export type SamlingStil = 'vertikal' | 'tabell' | 'vertikal--med-linje' | 'horisontal' | 'horisontal--en-linje' | 'horisontal--en-linje-spredd'
